import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { approvalChangeBenefits } from '../../slices/timesheet/timesheetApprovalDetails/timesheetApprovalBenefitCodes';
import { handleInitialBenefitCodes } from '../../../utils/middleware/benefitCodes';
import getBaseQueryWithReauth from '../../../utils/api/query-auth';
import getAuth from '../../../utils/api/getToken';

const LONG_CHACHE_TIME = 60 * 60 * 8; // 8 hours in seconds

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_BASE_URL}/Timesheet`,
  prepareHeaders: (headers) => {
    const token = getAuth();
    if (token) {
      headers.set('authorization', `Bearer ${token.auth}`);
    }
    return headers;
  },
});

export const benefitCodesApi = createApi({
  reducerPath: 'benefitcodes',
  baseQuery: getBaseQueryWithReauth(baseQuery),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getBenefitCodes: builder.query({
      // Accept driverId as argument
      query: (driverId: number) => {
        return `/getBenefitCodes?driverId=${driverId}`;
      },
      keepUnusedDataFor: LONG_CHACHE_TIME,
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            approvalChangeBenefits({
              benefitCodes: handleInitialBenefitCodes(data),
            }),
          );
        } catch {
          console.error('Error in getting Benefits data');
        }
      },
    }),
    getBenefitCodesRules: builder.query({
      query: ({ driverId, begin1, end1, begin2, end2, begin3, end3 }) => {
        let query = `/getBenefitCodesRules?driverId=${driverId}`;

        if (begin1 && end1) query += `&begin1=${begin1}&end1=${end1}`;
        if (begin2 && end2) query += `&begin2=${begin2}&end2=${end2}`;
        if (begin3 && end3) query += `&begin3=${begin3}&end3=${end3}`;

        return query;
      },
      keepUnusedDataFor: LONG_CHACHE_TIME,
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetBenefitCodesQuery, useGetBenefitCodesRulesQuery } =
  benefitCodesApi;
